<div class="subscription-modal">
    <div class="close-wrapper">
        <span class="material-icons close-icon-modal" (click)="close()">close</span>
    </div>
    <div class="subscription-invoice">
        <img src="{{logo}}" alt="logo">
        <h2>Invoice</h2>
    </div>
    <div class="subscription-billing">
        <div class="billing-left-wrapper">
            <div class="billing-box">
                <strong>Restaurant</strong>
                <h5>{{orderDetails?.ResturantName?.[0]?.Value || 'Restaurant Name'}}</h5>
                <!-- <p>{{Address?.AddressLine1?Address?.AddressLine1:''}} {{Address?.AddressLine2?Address?.AddressLine2:''}} {{Address?.City?Address?.City:''}}, {{Address?.State?Address?.State:''}}, {{Address?.ZipCode?Address?.ZipCode:''}}, {{this.Address?.Country?this.Address?.Country:''}}</p> -->
                 <p>{{orderDetails?.RestaurantAddress?orderDetails?.RestaurantAddress:''}}</p>
                <p>Phone:  {{orderDetails?.RestaurantPhoneNumber || ''}}</p>
                <p>Email : {{orderDetails?.RestaurantEmail || ''}}</p>
                <p>VAT number: 289.389.640 </p>
            </div>
        </div>
        <div class="billing-right-wrapper">
            <strong>Billed to</strong>
            <!-- <h5>Company Name Mr. Cristian Martin</h5> -->
            <h5>{{GuestName || 'Guest Name'}}</h5>
            <p>{{RestaurantAddress?.AddressLine1?RestaurantAddress?.AddressLine1:''}} {{RestaurantAddress?.AddressLine2?RestaurantAddress?.AddressLine2:''}} {{RestaurantAddress?.City?RestaurantAddress?.City:''}}, {{RestaurantAddress?.State?RestaurantAddress?.State:''}}, {{RestaurantAddress?.ZipCode?RestaurantAddress?.ZipCode:''}}, {{this.RestaurantAddress?.Country?this.RestaurantAddress?.Country:''}}</p>
            <p>Phone:{{orderDetails?.countryCode}} {{orderDetails?.PhoneNumber || 'N/A'}}</p>
            <p *ngIf="orderDetails?.roomNumber">Room: {{orderDetails?.roomNumber}}</p>
            <p *ngIf="orderDetails?.tableNumber">Table: {{orderDetails?.tableNumber}}</p>
        </div>
    </div>
    <div class="billing-invoice-wrapper">
        <div class="billing-invoice">
            <span class="billing-label">Invoice #</span>
            <span class="billing-detail">{{orderDetails?.InvoiceId || 'N/A'}}</span>
        </div>
        <div class="billing-invoice">
            <span class="billing-label">Date of issue</span>
            <span class="billing-detail">{{orderDetails?.CreatedAt | date:'dd-MMM-yyyy'}}</span>
        </div>
        <div class="billing-invoice">
            <span class="billing-label">Order ID</span>
            <span class="billing-detail">{{orderDetails?.orderId}}</span>
        </div>
    </div>
    <div class="services-detail-wrapper">
        <!-- <h2>Stay (Hotel Only) :</h2> -->
        <span><strong>Guest : </strong> {{orderDetails?.guestName}} </span>
    </div>

    <div class="billing-details">
        <div class="table-wrapper">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="Date">
                    <th class="date-time" mat-header-cell *matHeaderCellDef> Date & Time </th>
                    <td class="date-time" mat-cell *matCellDef="let element"> {{orderDetails?.CreatedAt | date:
                        'dd/MM/yyyy hh:mm a'}} </td>
                </ng-container>
                <ng-container matColumnDef="Itemname">
                    <th class="date-time" mat-header-cell *matHeaderCellDef> Item name </th>
                    <td class="date-time" mat-cell *matCellDef="let element"> {{element?.Itemname}} </td>
                </ng-container>

                <ng-container matColumnDef="Price">
                    <th class="plan" mat-header-cell *matHeaderCellDef> Price <span class="ml-5">(<span
                                class="secondary-text"
                                [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>)</span> </th>
                    <td class="plan" mat-cell *matCellDef="let element"> {{(element?.Price)?.toFixed(2)}} </td>
                </ng-container>

                <ng-container matColumnDef="Quantity">
                    <th class="plan" mat-header-cell *matHeaderCellDef> Quantity </th>
                    <td class="plan" mat-cell *matCellDef="let element"> {{element?.Quantity}} </td>
                </ng-container>

                <ng-container matColumnDef="Amount">
                    <th class="amount" mat-header-cell *matHeaderCellDef> Amount <span class="ml-5">(<span
                                class="secondary-text"
                                [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>)</span> </th>
                    <td class="amount" mat-cell *matCellDef="let element"> {{(element?.Amount)?.toFixed(2)}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <div class="tax-details">
            <div class="tax-block">
                <span class="tax-label">
                    Net amount:
                </span>
                <span class="tax-detail">
                    <span [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>
                    {{priceWithoutTax?.toFixed(2)}}
                </span>
            </div>
            <div class="tax-block">
                <span class="tax-label">
                    Tax amount {{formattedTaxRates}}:
                </span>
                <span class="tax-detail">
                    <span [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span> {{tax?.toFixed(2)}}
                </span>
            </div>
            <div class="tax-block">
                <span class="tax-label">
                    Tip:
                </span>
                <span class="tax-detail">
                    <span [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span> {{(orderDetails?.tip ||
                    0)?.toFixed(2)}}
                </span>
            </div>
            <div class="tax-block">
                <div class="total-amount">
                    <span class="tax-label">
                        Total amount:
                    </span>
                    <span class="tax-detail">
                        <span [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span> {{(this.priceWithoutTax
                        +this.tax+ (orderDetails?.tip || 0))?.toFixed(2)}}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <!-- <span class="in-words">
        In words: One Hundred Ten Dollars Only
    </span> -->
    <div class="payment-info">
        <h2>Payment Information :</h2>
        <span><strong>IBAN : &nbsp;</strong>  CH74 0900 0000 1457 3927 7 <span class="separate"></span> <strong>BIC :
                &nbsp;</strong>  POFICHBEXXX <span class="separate"></span><strong>Payment Reference &nbsp;</strong> (Invoice
            No.) {{orderDetails?.InvoiceId || 'N/A'}}</span>
    </div>


    <div class="billing-footer">
        <p>If you have any questions about this invoice, please contact our staff</p>
        <strong>Thank you for dining with us!</strong>
    </div>
</div>

<!-- <button (click)="print()">print</button>
<div style="height: 100vh; overflow: auto;">
    <table id="print" style="background: white; padding: 20px 40px; width: 100%; min-width: 100%; font-family: 'Roboto';">
        <tr>
            <td style="padding: 20px 40px;">
                <table style="width: 100%;">
                    <tr>
                        <td style="width: 10%;">
                            <img style="max-width: 106px;" src="{{logo}}" alt="logo">
                        </td>
                        <td style="width: 80%; padding: 0 15px; vertical-align: middle;">
                            <h2 style="text-align: center; font-size: 26px; color: #263238; margin: 0;">Invoice</h2>
                        </td>
                        <td style="width: 10%;"></td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="text-align: left; width: 28%; padding-top: 28px;">
                                        <strong style="font-size: 14px; display: block; margin-bottom: 19px;">Restaurant</strong>
                                        <h5
                                            style="font-size: 22px; font-weight: 500; color: #111429; line-height: 24px; margin-bottom: 10px;">
                                            {{orderDetails?.ResturantName?.[0]?.Value || 'Restaurant Name'}}</h5>
                                        <h6 style="font-size: 14px; color: #111429; margin-bottom: 8px;">Address Line 1, City 12345</h6>
                                        <p style="font-size: 14px; color: #111429; margin-bottom: 8px;">Phone: +1-123-456-7890</p>
                                        <p style="font-size: 14px; color: #111429; margin-bottom: 8px;">Email : info@restaurant.com</p>
                                        <p style="font-size: 14px; color: #111429;">VAT number: CHE-XXX>XXX>XXX VAT</p>
                                    </td>
                                    <td style="width: 50%;"></td>
                                    <td style="text-align: left; width: 22%; padding-top: 28px;">
                                        <strong
                                            style="font-size: 16px; margin-bottom: 6px; font-weight: 500; display: block;">Billed to</strong>
                                        <h5
                                            style="font-size: 20px; font-weight: 500; color: #111429; line-height: 24px; margin-bottom: 10px;">{{orderDetails?.guestName || 'Guest Name'}}</h5>
                                        <p style="font-size: 14px; color: #111429; margin-bottom: 8px;">Phone:{{orderDetails?.countryCode}} {{orderDetails?.PhoneNumber || 'N/A'}}</p>
                                        <p *ngIf="orderDetails?.roomNumber" style="font-size: 14px; color: #111429;">Room: {{orderDetails?.roomNumber}}</p>
                                        <p *ngIf="orderDetails?.tableNumber" style="font-size: 14px; color: #111429;">Table: {{orderDetails?.tableNumber}}</p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <table
                                style="border-top: 1px solid #E7E7E7; border-bottom: 1px solid #E7E7E7; margin: 15px 0 18px; width: 100%; text-align: left;">
                                <tr>
                                    <td style="width: 24%; padding: 14px 0;">
                                        <span
                                            style="display: block; font-size: 16px; line-height: 24px; margin-bottom: 6px; color: #111429;">Invoice
                                            #</span>
                                        <span
                                            style="font-size: 14px; color: #111429; display: block;">{{orderDetails?.InvoiceId || 'N/A'}}</span>
                                    </td>
                                    <td style="width: 24%; padding: 14px 15px;">
                                        <span
                                            style="display: block; font-size: 16px; line-height: 24px; margin-bottom: 6px; color: #111429;">Date
                                            of issue</span>
                                        <span style="font-size: 14px; color: #111429; display: block;">{{orderDetails?.CreatedAt | date:'dd-MMM-yyyy'}}</span>
                                    </td>
                                    <td style="width: 52%; padding: 14px 0;">
                                        <span
                                            style="display: block; font-size: 16px; line-height: 24px; margin-bottom: 6px; color: #111429;">Order ID</span>
                                        <span
                                            style="font-size: 14px; color: #111429; display: block;">{{orderDetails?.orderId}}</span>
                                    </td>
                                </tr>
                            </table>
                            <div style="margin-top: 8px; text-align: left;">
                                <span style="font-size: 14px;"><strong>Guest : </strong> {{orderDetails?.guestName}}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="padding: 10px 10px 15px;">
                                        <div style="box-shadow: 0px 0px 3px 0 rgb(0 0 0 / 20%); border-radius: 5px; margin: 0px 0 10px;">
                                            <div class="table-wrapper"  >
                                                <table mat-table [dataSource]="dataSource">
                                                    <ng-container matColumnDef="Date">
                                                        <th style="min-width: 200px; width: 34%;" mat-header-cell *matHeaderCellDef> Date & Time </th>
                                                        <td style="color: #000; font-size: 14px; font-family: 'Roboto'; padding: 12px 16px; border: none; width: 34%;" mat-cell *matCellDef="let element"> {{orderDetails?.CreatedAt | date: 'dd/MM/yyyy hh:mm a'}} </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="Itemname">
                                                        <th style="min-width: 150px; width: 32%" mat-header-cell *matHeaderCellDef> Item name </th>
                                                        <td style="color: #000; font-size: 14px; font-family: 'Roboto'; padding: 12px 16px; border: none; width: 32%;" mat-cell *matCellDef="let element"> {{element?.Itemname}} </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="Price">
                                                        <th style="width: 10%" mat-header-cell *matHeaderCellDef> Price </th>
                                                        <td style="color: #000; font-size: 14px; font-family: 'Roboto'; padding: 12px 16px; border: none; width: 10%;" mat-cell *matCellDef="let element"> {{(element?.Price)?.toFixed(2)}} </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="Quantity">
                                                        <th style="width: 10%;" mat-header-cell *matHeaderCellDef> Quantity </th>
                                                        <td style="color: #000; font-size: 14px; font-family: 'Roboto'; padding: 12px 16px; border: none; width: 10%;" mat-cell *matCellDef="let element"><span style="background: #ECF8ED; border-radius: 30px; padding: 0 15px;">{{element?.Quantity}}</span></td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="Amount">
                                                        <th style="width: 15%;" mat-header-cell *matHeaderCellDef> Amount </th>
                                                        <td style="color: #000; font-size: 14px; font-family: 'Roboto'; padding: 12px 16px; border: none; width: 15%;" mat-cell *matCellDef="let element"> {{(element?.Amount)?.toFixed(2)}} </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                                </table>
                                            </div>
                                            <div style="margin-top: 4px; padding-bottom: 20px; text-align: right;  padding: 0 16px;">
                                                <div style="margin-bottom: 10px;">
                                                    <span style="font-size: 14px; color: #111429; font-weight: 600;">
                                                        Net amount:
                                                    </span>
                                                    <span style="font-size: 14px; color: #111429; font-weight: 500; margin-left: 15px; min-width: 120px; display: inline-block;" [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri">
                                                        
                                                    </span>{{priceWithoutTax?.toFixed(2)}}
                                                </div>
                                                <div style="margin-bottom: 10px;">
                                                    <span style="font-size: 14px; color: #111429; font-weight: 600;">
                                                        Tax amount {{formattedTaxRates}}:
                                                    </span>
                                                    <span style="font-size: 14px; color: #111429; font-weight: 500; margin-left: 15px; min-width: 120px; display: inline-block;" [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri">
                                                    </span>
                                                    {{tax?.toFixed(2)}}
                                                </div>
                                                <div style="margin-bottom: 10px;">
                                                    <span style="font-size: 14px; color: #111429; font-weight: 600;">
                                                        Tip:
                                                    </span>
                                                    <span style="font-size: 14px; color: #111429; font-weight: 500; margin-left: 15px; min-width: 120px; display: inline-block;"  [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri">
                                                    </span>
                                                    {{(orderDetails?.tip || 0)?.toFixed(2)}}
                                                </div>
                                                <div style="padding-bottom: 15px;">
                                                    <span style="font-size: 14px; color: #111429; font-weight: 600;">
                                                        Total amount:
                                                    </span>
                                                    <span style="font-size: 14px; color: #111429; font-weight: 500; margin-left: 15px; min-width: 120px; display: inline-block;" [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri">
                                                    </span>
                                                    {{(this.priceWithoutTax +this.tax+ (orderDetails?.tip || 0))?.toFixed(2)}}
                                                </div>
                                            </div>
                                        </div>
                                        <span style="margin-top: 16px; text-align: right; font-size: 14px; display: block; color: #263238; font-weight: 500;">
                                            In words: One Hundred Ten Dollars Only
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <div style="margin: 6px 0 22px; padding-top: 15px; text-align: left; border-top: 1px solid #E0E0E0; page-break-before: page;">
                                <h2 style="font-size: 18px;
            margin-bottom: 10px;">Payment Information :</h2>
                                <span style="font-size: 14px;"><strong>IBAN : &nbsp;</strong> xxxx xxxx xxxx xxxx
                                    <strong
                                        style="padding-left: 10px; margin-left: 10px; border-left: 1px solid #E0E0E0;">BIC
                                        :
                                        &nbsp;</strong> (Code)<strong
                                        style="padding-left: 10px; margin-left: 10px; border-left: 1px solid #E0E0E0;">Payment Reference &nbsp;</strong> (Invoice No.) {{orderDetails?.InvoiceId || 'N/A'}} </span>
                            </div>

                            <div style="padding: 26px 20px 0; border-top: 1px solid #E0E0E0; text-align: center;">
                                <p style="font-size: 14px; color: #111429; margin: 0 0 12px;">If you have any questions about this invoice, please contact our staff</p>
                                <strong style="font-size: 20px;
                        color: #14413E;
                        font-weight: 500;">Thank you for dining with us!</strong>
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div> -->